import Filter from "./Filter";
import MobileFilter from "./mobile-filter/MobileFilter";

export const filter = {
    init: () => {
        const optionLists = document.querySelectorAll(".checkbox-list");
        [...optionLists].forEach((list) => new Filter(list));
    },
   
};

export default filter;
